import { TCieloMerchantRequest } from "../../../coreGlobal/models/admin/cieloMerchant"

export const BuildRequest = (data: TCieloMerchantRequest) => {

    return {
        name: data.name,
        merchant_id: data.merchant_id,
        merchant_key: data.merchant_key,
        ...(data.ec && data.ec.length > 0 && { ec: data.ec }),
        ...(data.expiration_at && data.expiration_at.length > 0 && { expiration_at: data.expiration_at }),
        active: data.active ?? true,
        franchise_id: data.franchise_id ?? null,
        billing_entity_id: data.billing_entity_id ?? null,
        payment_option_id: data.payment_option_id ?? null,
    }
}
